import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    contentsContainer: {
      '@media screen and (min-width:600px)': {
        borderTop: '1px solid #cfcfcf',
        height: 250,
        width: 500
      },
      '@media screen and (max-width:600px)': {
        height: 180,
        width: 340
      }
    },
    loadingContainer: {
      backgroundColor: '#F5F5F5',
      '@media screen and (min-width:600px)': {
        height: 250,
        width: 500
      },
      '@media screen and (max-width:600px)': {
        height: 210,
        width: 340
      }
    },
    userTextCoutainer: {
      '@media screen and (min-width:600px)': {
        padding: '20px 0 20px 0'
      },
      '@media screen and (max-width:600px)': {
        padding: '0 0 15px 0'
      }
    },
    userTitleText: {
      fontSize: '16px'
    },
    userNameText: {
      fontSize: '16px'
    },
    publishedUrlContainer: {
      backgroundColor: 'rgba(0,0,0,0.05)',
      padding: 15,
      borderRadius: 3,
      '@media screen and (min-width:600px)': {
        display: 'flex',
        alignItems: 'center'
      }
    },
    publishedUrlTextContainer: {
      minHeight: 100,
      wordBreak: 'break-all',
      fontSize: 14
    },
    copyLinkButton: {
      border: '1px solid gray',
      marginTop: 10,
      fontSize: 12
    },
    copyLinkButtonWrap: {
      '@media screen and (max-width:600px)': {
        textAlign: 'right'
      }
    },
    alertWrapper: {
      padding: '20px 0 0 0'
    }
  });
});
